<template>
  <div class="add-hemorrhage public-content">
    <div class="breadcrumb">编辑模板</div>
    <div class="third-title"><span>基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="templateGroupMsg" label-width="190px" ref="formRef">
        <el-form-item label="模板名称:">
          <el-input v-model="templateGroupMsg.groupName" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="尺寸组:">
          <el-table :data="[templateGroupMsg.composeSizeGroup]" border>
            <el-table-column type="expand">
              <template v-slot='scope'>
                <div style="width:100%;height:100%;background:red">
                  <el-table :data="scope.row.sizeList" border>
                    <el-table-column label="尺寸名称" prop="sizeName"></el-table-column>
                    <el-table-column label="页面类型" prop="typeName">
                      <template slot-scope="scope"> {{ $store.state.pms.pageType[scope.row.pageTypeCode] }} </template>
                    </el-table-column>
                    <el-table-column label="页面名称" prop="pageName"></el-table-column>
                    <el-table-column label="宽高">
                      <template slot-scope="scope"> {{ scope.row.sizeWidth }}x{{ scope.row.sizeHeight }}mm </template>
                    </el-table-column>
                    <el-table-column label="出血类型" prop="bleed.bleedName"></el-table-column>
                    <el-table-column label="出血" width="220px">
                      <template slot-scope="scope"> 上方：{{ scope.row.bleed.bleedTop }}mm 下方：{{ scope.row.bleed.bleedBottom }}mm <br> 左侧：{{ scope.row.bleed.bleedLeft }}mm 右侧：{{
                        scope.row.bleed.bleedRight }}mm <br> 内侧：{{ scope.row.bleed.bleedIn }}mm </template>
                    </el-table-column>
                    <el-table-column label="码" prop="barCodeId">
                      <template slot-scope="scope">
                        <p v-for="item in scope.row.barCodeList" :key="item.id">{{ item.barName }}</p>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="尺寸组名称" prop="groupName"></el-table-column>
            <el-table-column label="尺寸组类" prop="composeSizeGroupCategory.categoryName"></el-table-column>
            <el-table-column label="页面名称" prop="pageName">
              <template slot-scope="scope"> {{ scope.row.pageName && scope.row.pageName.substring(0, scope.row.pageName.length - 1) }} </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="是否关联该尺寸组:">
          <el-switch v-model="templateGroupMsg.isAssociatedeSizeGroup" :active-value='1' :inactive-value='0' active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)">
          </el-switch>
        </el-form-item>
        <el-form-item label="模板是否自动自适应:">
          <el-switch v-model="templateGroupMsg.photoAdaptation" active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)">
          </el-switch>
        </el-form-item>
        <el-form-item label="上传设计版是否弹预览封面:">
          <el-switch v-model="templateGroupMsg.previewCover" active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)" :active-value='1' :inactive-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="模板归属:">
          <el-radio v-model="templateGroupMsg.groupBelong" :label="0">全部</el-radio>
          <el-radio v-model="templateGroupMsg.groupBelong" :label="1">平台</el-radio>
        </el-form-item>
        <el-form-item v-if="templateGroupMsg.groupBelong === 1" label="模板归属平台:">
          <el-button style="margin:0 0 10px 0" @click="queryInfo.pageNum = 1, searchStoreList(), addStoreDialog = true" type="primary" round>添加平台</el-button>
          <el-table border :data="storeList" style="width: 100%">
            <el-table-column prop="code" label="平台号"></el-table-column>
            <el-table-column prop="name" label="平台名称"></el-table-column>
            <el-table-column prop="storeType" label="平台类型">
              <!-- <template slot-scope="scope">{{ $config.storeType[scope.row.storeType] || scope.row.storeType }}</template> -->
              <template slot-scope="scope">{{ storeType[scope.row.storeType] || scope.row.storeType }}</template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span @click="deleteStore(scope.$index)" class="color-blue">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="关联SKU:">
          <el-button style="margin:0 0 10px 0" @click="queryInfo.pageNum = 1, getSkuList(), addSkuDialog = true" type="primary" round>关联SKU</el-button>
          <el-table :data="templateGroupMsg.skuList" style="width: 100%">
            <el-table-column prop="skuName" label="SKU"></el-table-column>
            <el-table-column prop="skuGroupId" label="SKU组id"></el-table-column>
            <el-table-column prop="skuGroupName" label="SKU组名称"></el-table-column>
            <el-table-column prop="spuName" label="产品名称"></el-table-column>
            <el-table-column prop="address" label="SKU组图片">
              <template slot-scope="scope">
                <img style="width:100%" :src="scope.row.skuGroupImage" alt="">
              </template>
            </el-table-column>
            <el-table-column label="模板主图">
              <template slot-scope="scope">
                <div style="width:100%;position:relative;" v-if="scope.row.skuMainImage">
                  <img style="width:100%" :src="scope.row.skuMainImage" alt="">
                  <i class="el-icon-circle-close" style="color:#F56C6C;position:absolute;top:2px;right: 2px;z-index: 999;font-size: 18px;" @click="scope.row.skuMainImage = ''"></i>
                </div>
                <div class="upload-img" v-else>
                  <input type="file" name="" id="input_img" @change="fileSize($event, scope.row.skuId)" />
                  <span class="color-blue">上传主图</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="细节模板主图" width="180">
              <template slot-scope="scope">
                <div style="display:flex;flex-wrap:wrap;gap:5px;max-height:130px;overflow-y:auto;" v-if="scope.row.skuDetailImage && scope.row.skuDetailImage.length > 0">
                  <div v-for="(img, index) in scope.row.skuDetailImage" :key="index" style="position:relative;width:50px;height:50px;margin:2px;">
                    <img style="width:100%;height:100%;object-fit:cover;" :src="img" alt="">
                    <i class="el-icon-circle-close" style="color:#F56C6C;position:absolute;top:-5px;right:-5px;z-index: 999;font-size: 16px;cursor:pointer;"
                      @click="removeDetailImage(scope.row, index)"></i>
                  </div>
                </div>
                <div class="upload-img" v-else>
                  <input type="file" name="" multiple id="input_img" @change="fileSizeDetail($event, scope.row.skuId)" />
                  <span class="color-blue">上传细节图</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="操作">
              <template slot-scope="scope">
                <div class="color-blue" @click="templateGroupMsg.skuList.splice(scope.$index, 1)">删除</div>
                <div class="upload-pdf">
                  <input type="file" ref="pdfInput" name="pdf_file" accept=".pdf,application/pdf" style="display:none;" @change="uploadPdfFile($event, scope.row)" />
                  <span :class="{ 'color-blue': !scope.row.pdfUrl }" @click="triggerPdfUpload($event)">上传扉页通用烫金文件</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </div>
    <div class="third-title"><span>模板页信息</span></div>
    <div class="order-detail-basic">
      <el-form ref="form" :model="templateGroupMsg" label-width="110px">
        <el-form-item v-for="page in templateGroupMsg.templateList" :key='page.groupId + page.pageTypeCode'
          :label="page.pageTypeCode === 'COVER' ? '封面模板页' : page.pageTypeCode === 'TEXT' ? '内页模板页' : page.pageTypeCode === 'SINGLE' ? '单页模板' : '未定义'">
          <el-button type="primary" @click="correlation(page)" round>关联</el-button> <span>拖动修改模板顺序</span>
          <div class="imgbox">
            <draggable v-model="page.groupVos" chosenClass="chosen" forceFallback="true" group="people" animation="1000">
              <transition-group style="display: flex;flex-direction: row;flex-wrap:wrap;">
                <div v-for="(group, index) in page.groupVos" :key='group.id'
                  style="width:170px;border:1px solid #000;margin:5px 5px 0 0;display:flex;flex-direction: column;justify-content: space-between;">
                  <!-- <div class="imgBox">
                    <div class="img">
                      <el-image style="width:100%;height:100%;" :preview-src-list="group.templateThumbnailList" :src="group.templateThumbnailList[0]" fit="fill">
                      </el-image>
                    </div>
                    <div class="img" v-if="group.propertyId !== 2">
                      <el-image style="width:100%;height:100%;" :preview-src-list="group.templateThumbnailList" :src="group.templateThumbnailList[1]" fit="fill">
                      </el-image>
                    </div>
                  </div> -->
                  <templateThumbnail :templateGroup="group" />
                  <p style="text-align:center;border-top:1px solid #000;cursor: pointer;" @click="page.groupVos.splice(index, 1)">删除</p>
                </div>
              </transition-group>
            </draggable>
          </div>
        </el-form-item>
        <el-form-item label="封面预览图" v-show="templateGroupMsg.previewImagesCover && templateListCoverLength" prop="previewImagesCover">
          <input @change="spuTerminalIndexImage($event, 'previewImagesCover')" type="file" id="upload_C_single_img" style="display: none" multiple>
          <draggable v-model="templateGroupMsg.previewImagesCover.previewImages" chosenClass="chosen" filter=".filter" force-fallback="true" animation="300" class="upload_warp_img">
            <div class="upload_warp_img_div" v-for="(item, index) of templateGroupMsg.previewImagesCover.previewImages" :key="index">
              <div class="upload_img">
                <!-- <img :src="item.url"> -->
                <el-image :src="item.previewImage" fit='contain' style="width:100%;height:100%" :preview-src-list="[item.previewImage]">
                </el-image>
              </div>
              <div class="upload_warp_img_div_top">
                <p class="upload_warp_img_div_del color-blue" @click="fileDel(index, 'previewImagesCover')">删除图片</p>
              </div>
            </div>
            <div class="filter" style="float:left">
              <div class="upload_warp_left" @click="fileClick('upload_C_single_img')">
                <i class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
              </div>
            </div>
          </draggable>
        </el-form-item>
        <el-form-item>
          <p style="color: #999;line-height: 22px;" v-show="templateGroupMsg.previewImagesCover && templateListCoverLength">上传图片，建议上传该模板封面预览图，内存不得大于5M,封面数量和该模板页数量相同</p>
        </el-form-item>
        <el-form-item label="内页预览图" v-show="templateGroupMsg.previewImagesText && (templateListTextLength || templateListSingleLength)" prop="previewImagesText">
          <input @change="spuTerminalIndexImage($event, 'previewImagesText')" type="file" id="upload_T_single_img" style="display: none" multiple>
          <draggable v-model="templateGroupMsg.previewImagesText.previewImages" chosenClass="chosen" filter=".filter" force-fallback="true" animation="300" class="upload_warp_img">
            <div class="upload_warp_img_div" v-for="(item, index) of templateGroupMsg.previewImagesText.previewImages" :key="index">
              <div class="upload_img">
                <!-- <img :src="item.url"> -->
                <el-image :src="item.previewImage" fit='contain' style="width:100%;height:100%" :preview-src-list="[item.previewImage]">
                </el-image>
              </div>
              <div class="upload_warp_img_div_top">
                <p class="upload_warp_img_div_del color-blue" @click="fileDel(index, 'previewImagesText')">删除图片</p>
              </div>
            </div>
            <div class="filter" style="float:left">
              <div class="upload_warp_left" @click="fileClick('upload_T_single_img')">
                <i class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
              </div>
            </div>
          </draggable>
        </el-form-item>
        <el-form-item>
          <p style="color: #999;line-height: 22px;" v-show="templateGroupMsg.previewImagesText && templateListTextLength">上传图片，建议上传该模板内页预览图，内存不得大于5M,内页数量和该模板页数量相同</p>
        </el-form-item>
        <!-- <el-form-item label="模板主图" prop="mainImage">
          <input @change="spuTerminalIndexImage($event, 'mainImage')" type="file" id="upload_B_single_img"
            style="display: none">
          <div class="upload_warp_img_div" v-show="templateGroupMsg.mainImage.url">
            <div class="upload_img">
              <el-image :src="templateGroupMsg.mainImage.url" fit='contain' style="width:100%;height:100%" :preview-src-list="[templateGroupMsg.mainImage.url]">
              </el-image>
            </div>
            <div class="upload_warp_img_div_top" style="width: 170px;">
              <p class="upload_warp_img_div_del color-blue" @click="templateGroupMsg.mainImage.url = ''">删除图片</p>
            </div>
          </div>
          <div class="filter" style="float:left" v-show="!templateGroupMsg.mainImage.url">
            <div class="upload_warp_left" @click="fileClick('upload_B_single_img')">
              <i class="el-icon-plus avatar-uploader-icon" style="font-size: 30px;color: #999"></i>
            </div>
          </div>
        </el-form-item> -->
        <!-- <el-form-item>
          <p style="color: #999;line-height: 22px;">上传一张图片，建议尺寸292*292px</p>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary" @click="saveTemplateGourpMsg('save')">确定</el-button>
    </div>
    <!-- 添加平台 -->
    <el-dialog :close-on-click-modal="false" title="添加平台" :visible.sync="addStoreDialog" width="70%">
      <el-form :inline="true" :model="searchStoreVo" class="demo-form-inline">
        <el-form-item label="平台号:">
          <el-input v-model="searchStoreVo.code" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="平台名称:">
          <el-input v-model="searchStoreVo.name" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="平台类型 :">
          <el-select v-model="searchStoreVo.storeType" placeholder="请选择">
            <el-option v-for="item in storeTypeList" :key="item.id" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期:">
          <el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <div style="float:right;margin-right:20px">
          <el-button round @click="searchStoreList">查询</el-button>
          <el-button type="primary" @click="addStore" round>添加</el-button>
        </div>
      </el-form>
      <el-table :data="allStoreList" @selection-change="handleSelectionChange" style="width: 100%">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="code" label="平台号"></el-table-column>
        <el-table-column prop="name" label="平台名称"></el-table-column>
        <el-table-column prop="storeType" label="平台类型">
          <!-- <template slot-scope="scope">{{ $config.storeType[scope.row.storeType] || scope.row.storeType }}</template> -->
          <template slot-scope="scope">{{ storeType[scope.row.storeType] || scope.row.storeType }}</template>
        </el-table-column>
        <el-table-column prop="createdTime" label="创建日期"></el-table-column>
      </el-table>
      <v-pagination class="v-pagination" @changePage='changePage' :queryInfo='queryInfo'></v-pagination>
    </el-dialog>
    <!-- 关联SKU -->
    <el-dialog :close-on-click-modal="false" title="关联SKU" :visible.sync="addSkuDialog" width="70%">
      <el-form :inline="true" :model="templateSearchSkuVO" class="demo-form-inline">
        <el-form-item label="产品名称:">
          <el-input v-model="templateSearchSkuVO.spuName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="SKU名称 :">
          <el-input v-model="templateSearchSkuVO.skuGroupName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="尺寸组:">
          <span>{{ templateGroupMsg.composeSizeGroup.groupName }}</span>
        </el-form-item>
        <div style="float:right;margin-right:20px">
          <el-button @click="getSkuList()" round>查询</el-button>
          <el-button @click="addSku()" type="primary" round>关联</el-button>
        </div>
      </el-form>
      <el-table :data="skuList" style="width: 100%" @selection-change="selectSkuListChange" ref="skuTable">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="skuName" label="SKU名称"></el-table-column>
        <el-table-column prop="skuGroupId" label="SKU组id"></el-table-column>
        <el-table-column prop="skuGroupName" label="SKU组名称"></el-table-column>
        <el-table-column prop="spuName" label="产品名称"></el-table-column>
        <el-table-column prop="name" label="SKU组图片">
          <template slot-scope="scope">
            <img style="width:100%" :src="scope.row.skuGroupImage" alt="">
          </template>
        </el-table-column>
        <el-table-column prop="name" label="尺寸组">
          <template>{{ templateGroupMsg.composeSizeGroup.groupName }}</template>
        </el-table-column>
      </el-table>
      <v-pagination class="v-pagination" @changePage='changeSkuPage' :queryInfo='queryInfo'></v-pagination>
    </el-dialog>
    <!-- 关联模板 -->
    <el-dialog :close-on-click-modal="false" title="关联模板" :visible.sync="addFormatDialog" width="75%" @close="$refs.formatList.clearSelection()">
      <el-form :inline="true" :model="searchTemplateVo" class="demo-form-inline">
        <el-form-item label="设计人员:">
          <el-input v-model="searchTemplateVo.createdName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="模板主题:">
          <el-select clearable v-model="searchTemplateVo.templateThemeId" placeholder="">
            <el-option v-for="item in sampleList" :key="item.id" :label="item.themeName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期:">
          <el-date-picker v-model="value1" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="模板性质:">
          <el-select clearable v-model="searchTemplateVo.propertyId" placeholder="">
            <el-option v-for="item in FormatPropertyList" :key="item.id" :label="item.propertyName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="页面类型:">
          <span>{{ searchTemplateVo.pageTypeCode === 'COVER' ? '封面' : searchTemplateVo.pageTypeCode === 'TEXT' ? '内页' : searchTemplateVo.pageTypeCode === 'SINGLE' ? '单页' : '未定义' }}</span>
        </el-form-item>
        <el-form-item label="宽高:">
          <span>{{ searchTemplateVo.templateSize }}</span>
        </el-form-item>
        <el-form-item label="照片数量:">
          <el-input v-model="searchTemplateVo.imageCount" placeholder=""></el-input>
        </el-form-item>
        <div style="float:right;margin-right:20px">
          <el-button @click="searchFormatList()" round>查询</el-button>
          <el-button type="primary" @click="addFormat" round v-preventReClick>关联</el-button>
        </div>
      </el-form>
      <el-table :data="formatList" ref="formatList" row-key="id" @selection-change="handleFormatSelectionChange" style="width: 100%">
        <el-table-column type="selection" width="55" reserve-selection></el-table-column>
        <el-table-column prop="id" label="编号"></el-table-column>
        <el-table-column label="模板缩略图">
          <template slot-scope="scope">
            <div class="imgBox">
              <div class="img">
                <el-image style="width:100%;height:100%;" :preview-src-list="scope.row.templateThumbnailList" :src="scope.row.templateThumbnailList[0]" fit="fill"></el-image>
              </div>
              <div class="img" v-if="scope.row.propertyId !== 2">
                <el-image style="width:100%;height:100%;" :preview-src-list="scope.row.templateThumbnailList" :src="scope.row.templateThumbnailList[1]" fit="fill"></el-image>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="typeName" label="页面类型">
          <template slot-scope="scope"> {{ $store.state.pms.pageType[scope.row.pageTypeCode] }} </template>
        </el-table-column>
        <el-table-column prop="propertyName" label="性质">
          <template slot-scope="scope"> {{ propertyObj[scope.row.propertyId] }} </template>
        </el-table-column>
        <el-table-column prop="imageCount" label="照片数量"></el-table-column>
        <el-table-column prop="templateSize" label="宽高"></el-table-column>
        <el-table-column prop="createdName" label="设计人员"></el-table-column>
        <el-table-column prop="themeName" label="主题"></el-table-column>
        <el-table-column prop="createdTime" label="创建日期"></el-table-column>
      </el-table>
      <v-pagination class="v-pagination" @changePage='changeFormatPage' :queryInfo='queryInfo'></v-pagination>
    </el-dialog>
    <!-- 错误提示 -->
    <el-dialog :close-on-click-modal="false" title="错误提示" :visible.sync="tipDialog" width="30%">
      <span>{{ text }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tipDialog = false">取 消</el-button>
        <el-button type="primary" @click="tipDialog">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import templateThumbnail from '@/components/templateThumbnail.vue'
import VPagination from '@/components/Pagination/index.vue'
import draggable from 'vuedraggable'
import { groupQueryGroupById, storeGetStoreList, skuListAssociate, groupGetStoreListByGroupId, composeGroupDetail, groupUpdate, propertyGetPropertyList, templateGroupGetTemplateGroupList, sampleListNoPaging } from '@/api/pms'
import { storeTypeGetStoreTypeList } from '@/api/crm'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'
export default {
  name: 'add-hemorrhage',
  components: {
    draggable, VPagination, templateThumbnail
  },
  data () {
    return {
      selectSkuList: [],
      templateSearchSkuVO: {
        skuGroupName: '',
        spuName: ''
      },
      selectStoreList: [],
      storeList: [],
      allStoreList: [],
      value1: [],
      storeTypeList: [],
      addStoreDialog: false,
      addSkuDialog: false,
      addFormatDialog: false,
      templateListCoverLength: 0,
      templateListTextLength: 0,
      templateListSingleLength: 0,
      templateGroupMsg: {
        mainImage: {
          url: ''
        },
        previewImagesCover: {},
        previewImagesText: {},
        composeSizeGroup: {
          groupName: '',
          detail: {
            sizeList: []
          }
        },
        templateList: []
      },
      searchStoreVo: {
        code: '',
        createTimeBegin: '',
        createTimeEnd: '',
        id: '',
        name: '',
        page: 1,
        storeType: '',
        storeTypeid: ''
      },
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 6
      },
      searchTemplateVo: {
        createdName: '',
        auditStatus: 'AUDITED',
        createTimeBegin: '',
        createTimeEnd: '',
        imageCount: '',
        page: 1,
        pageTypeCode: '',
        propertyId: '',
        templateSize: '',
        templateThemeId: ''
      },
      sampleList: [],
      FormatPropertyList: [],
      propertyObj: {},
      formatList: [],
      selectFormatList: [],
      skuList: [],
      initialize: false,
      changeNum: 0,
      textPageNum: 0,
      text: '',
      tipDialog: false,
      itemGroup: [],
      storeType: [] // 平台类型
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    this.getTemplateGroupMsg()
    this.getStoreTypeList()
    this.getFormatSampleList()
    this.getFormatPropertyList()
    if (this.$route.query.maxPage) {
      this.$route.query.maxPage.forEach(item => {
        if (item.typeName === '内页') {
          this.textPageNum = item.templateGroupNum
          console.log(item.templateGroupNum, 'item.templateGroupNum')
        }
      })
    }
  },
  watch: {
    value1 (val) {
      this.searchTemplateVo.createTimeBegin = val === null ? '' : val[0]
      this.searchTemplateVo.createTimeEnd = val === null ? '' : val[1]
    },
    'templateGroupMsg.templateList': {
      handler (val, oldVal) {
        this.changeNum++
        //  ))
        if (this.initialize && this.changeNum > 2) {
          this.templateGroupMsg.change = true
        }
      },
      deep: true,
      immediate: false
    }
  },
  methods: {
    // 上传主图
    fileSize (data, id) {
      let file = data.target.files[0]
      var _this = this
      var reader = new FileReader()
      reader.onload = function (e) {
        var data = e.target.result
        // 加载图片获取图片真实宽度和高度
        var image = new Image()
        image.onload = function () {
          var width = image.width
          var height = image.height
          if (width === height) {
            _this.upload(file, id)
          } else {
            _this.$message.error('图片长宽不相同')
          }
        }
        image.src = data
      }
      reader.readAsDataURL(file)
    },
    // 上传图片
    upload (file, id) {
      console.log('fileType', file.type)
      if (['image/png', 'image/jpg', 'image/jpeg', 'image/webp'].indexOf(file.type) === -1) {
        this.$message.warning('请上传正确的图片格式')
        return
      }
      if (file.size > 1024 * 1024 * 1) {
        this.$message.error('图片大小不能超过1M')
        return
      }
      uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(res => {
        let skuList = this.templateGroupMsg.skuList.map(element => {
          if (element.skuId === id) {
            return {
              ...element,
              skuMainImage: res
            }
          } else {
            return element
          }
        })
        this.templateGroupMsg.skuList = skuList
        console.log('this.templateGroupMsg.skuList', this.templateGroupMsg.skuList)
        // this.$forceUpdate()
      })
    },
    // 上传细节图（支持多图）
    fileSizeDetail (data, id) {
      let files = Array.from(data.target.files)
      let _this = this

      let promises = files.map((file) => {
        return new Promise((resolve) => {
          if (['image/png', 'image/jpg', 'image/jpeg', 'image/webp'].indexOf(file.type) === -1) {
            _this.$message.warning(`${file.name} 格式不正确`)
            resolve(null)
            return
          }
          if (file.size > 1024 * 1024 * 1) {
            _this.$message.error(`${file.name} 大小不能超过1M`)
            resolve(null)
            return
          }
          var reader = new FileReader()
          reader.onload = function (e) {
            var result = e.target.result
            var image = new Image()
            image.onload = function () {
              if (image.width !== image.height) {
                _this.$message.error(`${file.name} 长宽不相同`)
                resolve(null)
              } else {
                resolve(file)
              }
            }
            image.src = result
          }
          reader.readAsDataURL(file)
        })
      })

      Promise.all(promises).then(results => {
        let validFiles = results.filter(f => f !== null)
        if (validFiles.length > 0) {
          _this.uploadDetailBatch(validFiles, id)
        }
      })
    },
    // 批量上传细节图到服务器
    uploadDetailBatch (files, id) {
      let uploadPromises = files.map(file => {
        return uploadWebImg(file, this.$store.state.awsSdk.product.s3)
      })

      Promise.all(uploadPromises).then(results => {
        let skuList = this.templateGroupMsg.skuList.map(element => {
          if (element.skuId === id) {
            let existingImages = element.skuDetailImage || []
            return {
              ...element,
              skuDetailImage: [...existingImages, ...results]
            }
          } else {
            return element
          }
        })
        this.templateGroupMsg.skuList = skuList
      })
    },
    // 删除单张细节图
    removeDetailImage (row, index) {
      row.skuDetailImage.splice(index, 1)
    },
    // 删除图片
    fileDel (index, listName) {
      // this.size = this.size - this.basicInfo.primaryImages[index].file.size// 总大小
      this.templateGroupMsg[listName].previewImages.splice(index, 1)
      this.addImageIndex(listName)
    },
    addImageIndex (listName) {
      this.templateGroupMsg[listName].previewImages.forEach((item, index) => {
        item.sortOrder = index
      })
    },
    // 触发PDF文件选择
    triggerPdfUpload (event) {
      const input = event.target.previousElementSibling
      if (input && input.type === 'file') {
        input.click()
      }
    },
    // 上传扉页通用烫金PDF文件
    uploadPdfFile (data, row) {
      const file = data.target.files[0]
      if (!file) return

      if (file.type !== 'application/pdf') {
        this.$message.warning('请上传PDF格式的文件')
        return
      }

      const maxSize = 70 * 1024 * 1024 // 10MB
      if (file.size > maxSize) {
        this.$message.error('PDF文件大小不能超过70M')
        return
      }
      let loading = this.$loading({
        lock: true,
        text: '正在上传文件，请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(async res => {
        if (res === 'error') {
          this.$message.error('PDF上传失败')
          return
        }

        // 更新行数据
        let skuList = this.templateGroupMsg.skuList.map(element => {
          if (element.skuId === row.skuId) {
            return {
              ...element,
              pdfUrl: res
            }
          } else {
            return element
          }
        })
        this.templateGroupMsg.skuList = skuList
        this.$forceUpdate() // 强制更新视图
        this.$message.success('PDF上传成功')
        loading.close()
      })
    },
    fileClick (id) {
      if (id === 'upload_C_single_img') {
        document.getElementById('upload_C_single_img').click()
        return
      }
      if (id === 'upload_T_single_img') {
        document.getElementById('upload_T_single_img').click()
        return
      }
      if (id === 'upload_B_single_img') {
        document.getElementById('upload_B_single_img').click()
        return
      }
      document.getElementById(id).click()
    },

    async spuTerminalIndexImage (e, listName) {
      console.log('e.target.files', e.target.files)
      let files = e.target.files
      for (let i = 0; i < files.length; i++) {
        if (listName !== 'mainImage') {
          if (files[i].size > 1024 * 1024 * 5) {
            this.$message.error('图片大小不能超过5M')
            return
          }
        }
        await uploadWebImg(files[i], this.$store.state.awsSdk.product.s3)
          .then(res => {
            if (listName === 'mainImage') {
              this.templateGroupMsg.mainImage = Object.assign({}, {
                url: res,
                mimetype: files[i].type,
                sortOrder: 0
              })
            } else {
              this.templateGroupMsg[listName].previewImages.push({
                previewImage: res,
                mimetype: files[i].type,
                sortOrder: this.templateGroupMsg[listName].previewImages.length
              })
              console.log('this.templateGroupMsg[listName].previewImages', this.templateGroupMsg[listName].previewImages)
            }
            console.log('this.templateGroupMsg', this.templateGroupMsg)
            this.$refs.form.validateField(listName)
          })
      }
    },
    // 点击关联
    async correlation (item) {
      console.log('groupVos', item.groupVos)
      this.itemGroup = item.groupVos
      this.searchTemplateVo.templateSize = item.sizeWidth + 'x' + item.sizeHeight + 'mm'
      this.searchTemplateVo.pageTypeCode = item.pageTypeCode
      this.queryInfo.pageNum = 1
      this.addFormatDialog = true
      await this.searchFormatList()
      // console.log('this.formatList', this.formatList)
    },
    // 获取sku列表
    getSkuList () {
      skuListAssociate({ composeSizeGroupId: this.templateGroupMsg.composeSizeGroup.id, pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, templateSearchSkuVO: this.templateSearchSkuVO }).then(res => {
        if (res.data.success) {
          this.skuList = res.data.data.records
          this.queryInfo.total = res.data.data.total
          if (this.skuList.length > 0) {
            let skuList = this.templateGroupMsg.skuList.map(a => {
              let selectList = {}
              this.skuList.forEach(b => {
                if (a.skuId === b.id) {
                  selectList = b
                }
              })
              return selectList
            })
            console.log('skuList', skuList)
            this.$nextTick(() => {
              skuList.forEach(row => {
                this.$refs.skuTable.toggleRowSelection(row)
              })
            })
          }
        }
      })
    },
    // 删除模板
    deleteTemp (item) {
    },
    // 编辑模板
    saveTemplateGourpMsg (type) {
      console.log('this.templateGroupMsg', this.templateGroupMsg)
      if (this.templateGroupMsg.previewImagesCover.previewImages.Length > 0 && this.templateGroupMsg.previewImagesCover.previewImages.length !== this.templateListCoverLength) {
        this.$message.warning('封面预览图与封面模板页数量不同')
        return
      }
      if (this.templateGroupMsg.previewImagesText.previewImages.length > 0 && this.templateGroupMsg.previewImagesText.previewImages.length !== this.templateListTextLength && this.templateListTextLength > 0) {
        this.$message.warning('内页预览图与内页模板页数量不同')
        return
      }
      if (this.templateGroupMsg.previewImagesText.previewImages.length > 0 && this.templateGroupMsg.previewImagesText.previewImages.length !== this.templateListSingleLength && this.templateListSingleLength > 0) {
        this.$message.warning('内页预览图与单页模板页数量不同')
        return
      }
      // if (!this.templateGroupMsg.mainImage.url) {
      //   this.$message.warning('请上传模板主图')
      //   return
      // }
      let list1 = this.templateGroupMsg.previewImagesCover?.previewImages?.map((res, index) => {
        return {
          pageTypeCode: this.templateGroupMsg.previewImagesCover.pageTypeCode,
          previewImage: res.previewImage,
          sorting: index
        }
      }) || []

      let list2 = this.templateGroupMsg.previewImagesText?.previewImages?.map((res, index) => {
        return {
          pageTypeCode: this.templateGroupMsg.previewImagesText.pageTypeCode,
          previewImage: res.previewImage,
          sorting: index
        }
      }) || []
      let aaa = list1.concat(list2)

      let templateXrefVos = {
        change: this.templateGroupMsg.change,
        composeSizeGroupId: this.templateGroupMsg.composeSizeGroupId,
        groupBelong: this.templateGroupMsg.groupBelong,
        groupName: this.templateGroupMsg.groupName,
        id: this.templateGroupMsg.id,
        previewCover: this.templateGroupMsg.previewCover,
        photoAdaptation: this.templateGroupMsg.photoAdaptation,
        isAssociatedeSizeGroup: this.templateGroupMsg.isAssociatedeSizeGroup,
        skuIds: [],
        storeIds: [],
        templateXrefVos: [],
        textPageNum: 0,
        previewImages: aaa
      }
      let noMain = []
      let skuList = []
      console.log('this.templateGroupMsg.skuList', this.templateGroupMsg.skuList)
      this.templateGroupMsg.skuList.forEach(ele => {
        if (ele.skuMainImage) {
          skuList.push({
            skuMainImage: ele.skuMainImage,
            pdfUrl: ele.pdfUrl,
            skuId: ele.skuId,
            templateImageList: ele.skuDetailImage || []
          })
        } else {
          noMain.push(false)
        }
      })
      if (noMain.length > 0) {
        this.$message.warning('请上传模板主图')
        return
      }
      if (this.templateGroupMsg.groupBelong === 1) {
        this.storeList.forEach(item => {
          templateXrefVos.storeIds.push(item.storeId)
        })
      }
      this.templateGroupMsg.skuList.forEach(item => {
        templateXrefVos.skuIds.push(item.id ? item.id : item.skuId)
      })
      this.templateGroupMsg.templateList.forEach(page => {
        let obj = {
          pageTypeCode: page.pageTypeCode,
          templateGroups: []
        }
        page.groupVos.forEach((group, index) => {
          obj.templateGroups.push({
            sorting: index + 1,
            templateGroupId: group.id
          })
        })
        templateXrefVos.templateXrefVos.push(obj)
      })
      let TEXTNUM = 0
      let SINGLENUM = 0
      let COVERNUM = 0
      templateXrefVos.templateXrefVos.forEach(k => {
        console.log('kkkkkkkk', k)
        // if (k.pageTypeCode === 'TEXT') {
        //   templateXrefVos.textPageNum = k.templateGroups.length
        // }
        // 新增了是否判断
        if (k.pageTypeCode === 'TEXT') {
          TEXTNUM = this.textIsBase ? k.templateGroups.length : 0
        }
        if (k.pageTypeCode === 'SINGLE') {
          SINGLENUM = this.singleIsBase ? k.templateGroups.length : 0
        }
        if (k.pageTypeCode === 'COVER') {
          COVERNUM = this.coverIsBase ? k.templateGroups.length : 0
        }
        templateXrefVos.textPageNum = TEXTNUM + SINGLENUM + COVERNUM
      })
      if (type === 'save') {
        groupUpdate({ ...templateXrefVos, skuList: skuList }).then(res => {
          if (res.data.success) {
            this.$message.success('修改成功')
            this.$router.go(-1)
          }
        })
        // .catch((i) => {
        //   console.log(i, 'aaaaaaaaaaaaa')
        //   this.tipDialog = true
        //   this.text = '11111111111'
        // })
      } else if (type === 'new') {
      }
    },
    // 关联模板
    addFormat () {
      this.templateGroupMsg.templateList.forEach(page => {
        if (page.pageTypeCode === this.searchTemplateVo.pageTypeCode) {
          page.groupVos = JSON.parse(JSON.stringify(this.selectFormatList))
        }
      })
      this.$refs.formatList.clearSelection()
      this.addFormatDialog = false
    },
    // 获取模板性质
    getFormatPropertyList () {
      propertyGetPropertyList().then(res => {
        if (res.data.success) {
          this.propertyObj = res.data.data.reduce((obj, item) => {
            obj[item.id] = item.propertyName
            return obj
          }, {})
          this.FormatPropertyList = res.data.data
        }
      })
    },
    // 获取模板主题
    getFormatSampleList () {
      sampleListNoPaging().then(res => {
        if (res.data.success) {
          this.sampleList = res.data.data
        }
      })
    },
    // 获取模板列表
    async searchFormatList () {
      await templateGroupGetTemplateGroupList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, searchTemplateVo: this.searchTemplateVo }).then(res => {
        if (res.data.success) {
          let obj = res.data.data.records

          obj.forEach(item => {
            if (item.propertyId === 2) {
              item.templateThumbnailList = [item.templates[0].templateThumbnail]
            } else {
              item.templateThumbnailList = item.templates.reduce((list, temp) => {
                list[temp.templatePosition] = temp.templateThumbnail
                return list
              }, [])
            }
          })
          this.formatList = obj
          this.queryInfo.total = res.data.data.total
          this.itemGroup.forEach(res => {
            this.formatList.forEach(a => {
              // console.log('aaaaa', res.id, a.id)
              if (res.id == a.id) {
                // console.log('aaaaa', a)
                this.$refs.formatList.toggleRowSelection(a)
              }
            })
          })
        }
      })
    },
    // 删除平台
    deleteStore (index) {
      this.storeList.splice(index, 1)
    },
    // 添加sku
    addSku () {
      // this.templateGroupMsg.skuList = []
      // <====新增
      this.selectSkuList.forEach(val => {
        this.templateGroupMsg.skuList.forEach(itm => {
          if (val.id === itm.skuId) {
            val.isRepeat = true
          }
        })
      })
      let selectSkuList = []
      this.selectSkuList.map((item) => {
        // 通过标记筛选对象
        if (!item.isRepeat) {
          selectSkuList.push(item)
        }
      }) // ====>

      // ...this.selectSkuList
      this.templateGroupMsg.skuList.push(...selectSkuList)
      console.log('this.templateGroupMsg.skuList', this.templateGroupMsg.skuList)
      this.templateGroupMsg.skuList = this.templateGroupMsg.skuList.map(res => {
        return {
          ...res,
          skuId: res.id || res.skuId
        }
      })
      console.log(this.templateGroupMsg)
      this.addSkuDialog = false
    },
    // 添加平台
    addStore () {
      this.selectStoreList.forEach(val => {
        let lock = true
        this.storeList.forEach(item => {
          if (val.storeId === item.storeId) {
            lock = false
          }
        })
        if (lock) {
          this.storeList.push(val)
        }
      })
      this.addStoreDialog = false
    },
    // 搜索平台
    searchStoreList () {
      storeGetStoreList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, searchStoreVo: this.searchStoreVo }).then(res => {
        if (res.data.success) {
          this.allStoreList = res.data.data.records
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    // 获取平台类型
    getStoreTypeList () {
      storeTypeGetStoreTypeList().then(res => {
        if (res.data.success) {
          this.storeTypeList = res.data.data
          this.storeType = []
          let storeTypeData = res.data.data
          const montage = (storeTypeData) => {
            let obj = {}
            for (let v of storeTypeData) {
              obj[v.code] = v.name
            }
            return obj
          }
          this.storeType = montage(storeTypeData)
        }
      })
    },
    getTemplateGroupMsg () {
      groupQueryGroupById(this.$route.query.id).then(res => {
        if (res.data.success) {
          this.getSizeGroupMsg(res.data.data.composeSizeGroupId, res.data.data)
        }
      })
    },
    // 获取尺寸组详细信息
    getSizeGroupMsg (id, obj) {
      console.log('obj', obj)
      composeGroupDetail(id).then(res => {
        if (res.data.success) {
          obj.composeSizeGroup = res.data.data
          res.data.data.sizeList.forEach(size => {
            // 新增-----内页，封面，单页是否计入基础P数判断条件
            if (size.spuPageName.pageTypeCode === 'TEXT') { // 内页
              this.textIsBase = size.spuPageName.isBase
            } else if (size.spuPageName.pageTypeCode === 'COVER') { // 封面
              this.coverIsBase = size.spuPageName.isBase
            } else if (size.spuPageName.pageTypeCode === 'SINGLE') { // 单页
              this.singleIsBase = size.spuPageName.isBase
            }
          })
        }
        this.storeList = obj.storeList
        obj.change = false
        // 回显细节模板主图
        if (obj.skuList && obj.skuList.length > 0) {
          obj.skuList.forEach(sku => {
            if (sku.templateImageList && sku.templateImageList.length > 0) {
              sku.skuDetailImage = sku.templateImageList.map(a => {
                return a.imageUrl
              })
            }
          })
        }
        obj.templateList.forEach(page => {
          if (page.pageTypeCode === 'COVER') this.templateListCoverLength = page.groupVos.length
          if (page.pageTypeCode === 'TEXT') this.templateListTextLength = page.groupVos.length
          if (page.pageTypeCode === 'SINGLE') this.templateListSingleLength = page.groupVos.length
          page.groupVos.forEach(group => {
            if (group.propertyId === 2) {
              group.templateThumbnailList = [group.templates[0].templateThumbnail]
            } else {
              group.templateThumbnailList = group.templates.reduce((list, temp) => {
                console.log(temp.templatePosition)
                list[temp.templatePosition] = group.templateThumbnail
                return list
              }, [])
            }
          })
        })
        obj.previewImagesCover = {
          previewImages: []
        }
        obj.previewImagesText = {
          previewImages: []
        }
        obj.previewImageVoList.forEach(val => {
          if (val.pageTypeCode === 'COVER') {
            obj.previewImagesCover = val
          } else if (val.pageTypeCode === 'TEXT') {
            console.log(val)
            obj.previewImagesText = val
          } else if (val.pageTypeCode === 'TEXT' || val.pageTypeCode === 'SINGLE') {
            obj.previewImagesText = val
          }
        })
        this.templateGroupMsg = obj
        this.templateGroupMsg.mainImage = {
          url: obj.mainImage
        }
        console.log('关联 this.templateGroupMsg', this.templateGroupMsg)
        this.initialize = true
      })
    },
    handleSelectionChange (val) {
      this.selectStoreList = val
    },
    handleFormatSelectionChange (val) {
      this.selectFormatList = val
    },
    selectSkuListChange (val) {
      this.selectSkuList = val
    },
    changePage (val) {
      this.queryInfo = val
      this.searchStoreList()
    },
    changeFormatPage (val) {
      this.queryInfo = val
      this.searchFormatList()
    },
    changeSkuPage (val) {
      this.queryInfo = val
      this.getSkuList()
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.add-hemorrhage {
  .spec-mm {
    span {
      margin-right: 10px;
    }

    .el-input {
      width: 110px;
    }

    @{deep} .el-input-group__append {
      padding: 0 15px;
    }
  }

  .link {
    width: 30px;
    height: 30px;
    border: 1px solid #dcdfe6;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    box-sizing: border-box;

    i {
      font-size: 20px;
      color: #999;
    }
  }

  .active-link {
    background: #1473e6;
    border: 1px solid #1473e6;

    i {
      color: #fff;
    }
  }
}

.imgBox {
  width: 100%;
  display: flex;
  justify-content: space-around;

  .img {
    flex: 1;
  }
}

.upload_warp_img {
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .upload_warp_img_div {
    margin: 5px;
    border: 1px solid #D2D2D2;
  }
}

.upload_warp_img_div_top {
  display: flex;
  width: 100%;
  align-items: center;
  background: #f9fafc;
  justify-content: center;
  line-height: 36px;
  border-top: 1px solid #ececec;
}

.upload_warp_img_div_del {
  padding-left: 10px;
}

.upload_warp_left {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 170px;
  height: 207px;
  border: 1px solid #666;
  cursor: pointer;
  flex-flow: column;

  i {
    margin-bottom: 10px;
    // display: block;
    // width: 100%;
    // height: 100%;
  }

  div {
    color: #666;
    font-size: 16px;
  }
}

.upload_img {
  width: 170px;
  height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: hidden;

  img {
    width: 100%;
  }
}

.upload-pdf {
  position: relative;
  cursor: pointer;

  input[type="file"] {
    display: none;
  }
}
</style>
